import React, { useState } from 'react';
import { ArrowRight, ExternalLink, CheckCircle2 } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const ACADEMY_URL = 'https://www.freezedryacademy.com';

// Email opt-in that captures a rebuild lead, then opens Freeze Dry Academy.
export const AcademyOptIn = ({ variant = 'dark', source = 'academy-optin', testid = 'academy-optin' }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const dark = variant === 'dark';

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email.');
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API_URL}/api/leads/capture`, {
        email,
        lead_type: 'academy_interest',
        source,
        notes: 'Freeze Dry Academy opt-in. Interested in learning and a potential rebuild.',
      });
    } catch (err) { /* non-blocking */ }
    setLoading(false);
    setDone(true);
    window.open(ACADEMY_URL, '_blank', 'noopener,noreferrer');
    toast.success("You're on the list, opening Freeze Dry Academy now.");
  };

  if (done) {
    return (
      <p className={`inline-flex items-center gap-2 text-sm font-semibold ${dark ? 'text-white' : 'text-[#003456]'}`} data-testid={`${testid}-done`}>
        <CheckCircle2 className="h-5 w-5 text-[#CE8946]" /> Thanks! Freeze Dry Academy is opening in a new tab.
      </p>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2 w-full" data-testid={testid}>
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email"
        className={`flex-1 px-4 py-3 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#CE8946] ${dark ? 'bg-white/10 border border-white/20 text-white placeholder:text-white/50' : 'bg-white border border-slate-300 text-[#003456]'}`}
        data-testid={`${testid}-email`}
      />
      <button
        type="submit"
        disabled={loading}
        className="inline-flex items-center justify-center gap-2 bg-[#CE8946] hover:bg-[#B87333] disabled:opacity-60 text-[#003456] font-bold px-6 py-3 rounded-md transition-colors whitespace-nowrap"
        data-testid={`${testid}-submit`}
      >
        {loading ? 'Sending…' : (<>Get access <ExternalLink className="h-4 w-4" /></>)}
      </button>
    </form>
  );
};

export default AcademyOptIn;
